export default __webpack_public_path__ + "images/1e51e6f0cb9e4e89c4ca70551c22e000-cc-mini-back.png";